export default __webpack_public_path__ + "static/media/img_19.38c8bb0e.jpg";